import React from "react";
import gql from "graphql-tag";
import parseISO from "date-fns/fp/parseISO";
import format from "date-fns/format";
import { Box, Flex, Text, ChevronRight, TouchableOpacity } from "@atoms";
import { useToggle } from "@hooks";
import { FundsPagePaymentQuery } from "../FundsPagePayment";
import { FundsPageWithdrawalsListItemFragment } from "./__generated__/FundsPageWithdrawalsListItemFragment";

// == Types ================================================================

interface IProps {
  listItem: FundsPageWithdrawalsListItemFragment;
}

// == Constants ============================================================

FundsPageWithdrawalsListItem.fragments = gql`
  fragment FundsPageWithdrawalsListItemFragment on Payment {
    id
    processedAt
    amount {
      formatted
    }
  }
`;

// == Component ============================================================

export default function FundsPageWithdrawalsListItem({ listItem }: IProps) {
  const { id, processedAt, amount } = listItem;
  const [isModalOpen, setModalOpen] = useToggle(false);

  return (
    <>
      <TouchableOpacity onTouch={() => setModalOpen(true)}>
        <Flex alignItems="center" justifyContent="space-between" padding={3} width="100%">
          <Flex alignItems="center">
            <Box>
              {processedAt ? (
                <Text fontSize={[1, 1, 2]}>{format(parseISO(processedAt), "MMM d, yyyy")}</Text>
              ) : (
                <Text paddingRight={[1, 2]}>Processing...</Text>
              )}
            </Box>
          </Flex>

          <Flex alignItems="center">
            <Text fontSize={[1, 1, 2]} paddingRight={3}>
              {amount.formatted}
            </Text>
            <ChevronRight color="#666" size="xs" />
          </Flex>
        </Flex>
      </TouchableOpacity>
      {isModalOpen && (
        <FundsPagePaymentQuery
          isModalOpen={isModalOpen}
          paymentId={id}
          setModalOpen={setModalOpen}
        />
      )}
    </>
  );
}

// == Styles ===============================================================
